













import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import EpisodeBody from '@/views/templates/kuntama/parts/EpisodeBody.vue'

export default
  components: {
    EpisodeTitle
    EpisodeBody
  }

  data: () ->
    text: [
      '桑野さんは、柔道に打ち込むため高校時代から親元を離れて過ごしていました。ある日、お父さんから“燻らのたまご”が桑野さんの元へ届けられますが、そのことをすっかり忘れてしまい…思い出した頃には約1ヶ月が過ぎ去っていました。<br>はじめは口にすることを躊躇しましたが、恐る恐る一口食べてみると、そのおいしさにびっくり！なんだか力がみなぎってくるようではありませんか。桑野さんは、“燻らのたまご”のおいしさとパワーに驚きと感動をお覚えました。'
      '大学を卒業した桑野さんは、これまでどんなときも温かく見守り、支えてくれたご両親への感謝の思いから、家業を手伝うことを決意。<span class="red">お父さんが丹精込めて作った“燻らのたまご”のおいしさや魅力をひとりでも多くの方に広めるため、「くんたま王子」として大阪でお店を構えています。</span>'
    ]
